import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { TopbarContainer } from '..';
import {
  Page,
  LayoutSideNavigation,
  LayoutWrapperMain,
  LayoutWrapperSideNav,
  LayoutWrapperTopbar,
  LayoutWrapperFooter,
  Footer,
  LandownerReferral,
} from '../../components';
import config from '../../config';

import css from './LandownerReferralPage.module.css';

const LandownerReferralPageComponent = props => {
  const { scrollingDisabled, intl } = props;

  const tabs = [
    {
      text: intl.formatMessage({ id: 'LandownerReferralPage.privacyTabTitle' }),
      selected: false,
      linkProps: {
        name: 'PrivacyPolicyPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'LandownerReferralPage.tosTabTitle' }),
      selected: false,
      linkProps: {
        name: 'TermsOfServicePage',
      },
    },
    {
      text: intl.formatMessage({ id: 'LandownerReferralPage.LandownerReferralTitle' }),
      selected: true,
      linkProps: {
        name: 'LandownerReferralPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'LandownerReferralPage.AgritourismStatutesTitle' }),
      selected: false,
      linkProps: {
        name: 'AgritourismStatutesPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'TermsOfServicePage.MobileTermsOfServiceTitle' }),
      selected: false,
      linkProps: {
        name: 'MobileTermsOfServicePage',
      },
    },
  ];
  const { siteTitle } = config;
  const schemaTitle = intl.formatMessage(
    { id: 'LandownerReferralPage.schemaTitle' },
    { siteTitle }
  );
  const schema = {
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    name: schemaTitle,
  };
  return (
    <Page title={schemaTitle} scrollingDisabled={scrollingDisabled} schema={schema}>
      <LayoutSideNavigation>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="LandownerReferralPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperSideNav tabs={tabs} />
        <LayoutWrapperMain>
          <div className={css.content}>
            <h1 className={css.heading}>
              <FormattedMessage id="LandownerReferralPage.heading" />
            </h1>
            <LandownerReferral />
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSideNavigation>
    </Page>
  );
};

const { bool } = PropTypes;

LandownerReferralPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const LandownerReferralPage = compose(
  connect(mapStateToProps),
  injectIntl
)(LandownerReferralPageComponent);

export default LandownerReferralPage;
